export const MoreIcon = ({
  strokeColor = "var(--color-icon-bright)",
  _className,
  ...props
}: any) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g id="vuesax/outline/more">
      <g id="more">
        <path
          className={_className}
          id="Vector"
          d="M12.2918 15.8333C12.2918 17.1 11.2668 18.125 10.0002 18.125C8.7335 18.125 7.7085 17.1 7.7085 15.8333C7.7085 14.5667 8.7335 13.5417 10.0002 13.5417C11.2668 13.5417 12.2918 14.5667 12.2918 15.8333ZM8.9585 15.8333C8.9585 16.4083 9.42516 16.875 10.0002 16.875C10.5752 16.875 11.0418 16.4083 11.0418 15.8333C11.0418 15.2583 10.5752 14.7917 10.0002 14.7917C9.42516 14.7917 8.9585 15.2583 8.9585 15.8333Z"
          fill={strokeColor}
        />
        <path
          className={_className}
          id="Vector_2"
          d="M12.2918 4.16732C12.2918 5.43398 11.2668 6.45898 10.0002 6.45898C8.7335 6.45898 7.7085 5.43398 7.7085 4.16732C7.7085 2.90065 8.7335 1.87565 10.0002 1.87565C11.2668 1.87565 12.2918 2.90065 12.2918 4.16732ZM8.9585 4.16732C8.9585 4.74232 9.42516 5.20898 10.0002 5.20898C10.5752 5.20898 11.0418 4.74232 11.0418 4.16732C11.0418 3.59232 10.5752 3.12565 10.0002 3.12565C9.42516 3.12565 8.9585 3.59232 8.9585 4.16732Z"
          fill={strokeColor}
        />
        <path
          className={_className}
          id="Vector_3"
          d="M12.2918 9.99935C12.2918 11.266 11.2668 12.291 10.0002 12.291C8.7335 12.291 7.7085 11.266 7.7085 9.99935C7.7085 8.73268 8.7335 7.70768 10.0002 7.70768C11.2668 7.70768 12.2918 8.73268 12.2918 9.99935ZM8.9585 9.99935C8.9585 10.5743 9.42516 11.041 10.0002 11.041C10.5752 11.041 11.0418 10.5743 11.0418 9.99935C11.0418 9.42435 10.5752 8.95768 10.0002 8.95768C9.42516 8.95768 8.9585 9.42435 8.9585 9.99935Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
